import React from 'react';
import { useNavigate } from 'react-router-dom'; // If using react-router-dom for navigation

const PageNotFount = () => {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      {/* Displaying 404 Message */}
      <h1 className="text-5xl font-bold text-red-500 mb-4">404</h1>
      <p className="text-xl text-gray-700 mb-6">Oops! The page you're looking for doesn't exist.</p>

      {/* Back to Home Button */}
      <button
        onClick={() => navigate('/SignInCandidate')}  // Change path as needed (e.g., navigate(-1) for the previous page)
        className="bg-blue-500 text-white px-6 py-3 rounded-lg shadow hover:bg-blue-600 transition duration-300"
      >
        Go Back to Home
      </button>
    </div>
  );
};

export default PageNotFount;
